module.exports = __webpack_public_path__ + "img/ex.57f1ba80.png";